import Turbolinks from 'turbolinks'

export function bindToFormErrors() {
  // due to https://github.com/turbolinks/turbolinks/issues/85
  setTimeout(function() {
    Array.from(document.querySelectorAll('form.handle-422')).forEach((el) => {
      el.addEventListener('ajax:error', function(e) {
        if (e.detail[2].status !== 422) {
          return
        }

        const xhr = event.detail[2]
        Turbolinks.clearCache()
        const parser = new DOMParser()
        const doc = parser.parseFromString(xhr.responseText, 'text/html')
        document.documentElement.replaceChild(doc.body, document.body)
        Turbolinks.dispatch('turbolinks:load')
        // app.notify('Update error', {type: 'error'})
      })
    })
  }, 500)
}
